import { render, staticRenderFns } from "./settleModel.vue?vue&type=template&id=f09a7880&scoped=true"
import script from "./settleModel.vue?vue&type=script&lang=js"
export * from "./settleModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09a7880",
  null
  
)

export default component.exports